<template>
  <div class="explore-units-page">
    <div class="container">
      <SearchPaginatedList
        :is-searching="isSearching"
        :is-initial-loading="false"
        :query="q"
        :page-data="authors"
      >
        <template #list-header>
          <header class="card">
            <div class="card-row">
              <div class="card-row__text">
                <p>{{ $t('scientific.interest') }}</p>
                <h1 class="card-row__title">
                  {{ q }}
                </h1>
                <p>
                  <b>{{ $t('scientific.interest.total.p1', totalResults) }}</b>
                  {{ $t('scientific.interest.total.p2', totalResults) }}
                </p>
              </div>
            </div>
          </header>
        </template>
        <template #list-skeleton>
          <UserSkeleton
            :count="6"
            class="card-list"
          />
        </template>
        <template #list>
          <ul class="card card-list">
            <li
              v-for="user in users"
              :key="user.id"
              class="card-row"
            >
              <UserAvatar
                :name="user.name"
                :src="user.avatar"
                class="card-row__figure"
              />
              <div class="card-row__text">
                <h1 class="card-row__title h5--ssp">
                  <RouterLink
                    :to="{ name: 'ResearcherPage', params: { userId: user.username } }"
                    class="card-row__link"
                  >
                    {{ user.name }}
                  </RouterLink>
                </h1>
                <p>{{ user.username }}</p>
              </div>
            </li>
          </ul>
        </template>
        <template #pagination>
          <PaginationBar
            v-if="users"
            :current-page="currentPage"
            :total-items="totalResults"
            :items-per-page="perPage"
          />
        </template>
      </SearchPaginatedList>
    </div>
  </div>
</template>

<script>
import UserAvatar from '#src/components/utils/UserAvatar.vue'
import PaginationBar from '#src/components/utils/PaginationBar.vue'
import SearchPaginatedList from '#src/components/utils/SearchPaginatedList.vue'
import UserSkeleton from '#src/components/loading-skeletons/User.vue'

import useResearchersAPI from '#src/api/researchers'
import { useHeadSafe } from '@unhead/vue'
import { useI18n } from 'vue-i18n'

export default {
  components: {
    UserAvatar,
    PaginationBar,
    SearchPaginatedList,
    UserSkeleton
  },
  inject: ['$axios'],
  async beforeRouteUpdate(to, from, next) {
    this.currentPage = Number(to.query.page) || 1
    this.isSearching = true
    to.params.perPage = Number(this.perPage)
    to.meta.authors = await this.ResearchersAPI.listByScientificInterest({ scientificInterest: to.query.q, page: this.currentPage, perPage: this.perPage })
    this.isSearching = false
    if (!import.meta.env.SSR && to.query.perPage) localStorage.setItem('perPage', Number(to.query.perPage) || 10)
    next()
  },
  props: {
    page: {
      type: Number,
      required: true
    },
    authors: {
      type: Object,
      required: true
    },
    perPage: {
      type: Number,
      default: (!import.meta.env.SSR ? Number(localStorage.getItem('perPage')) : null) || 10
    },
    q: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const { t } = useI18n({
      messages: {
        pt: {
          title: '{interest} - Interesses científicos',
          description: 'Uma lista de investigadores com interesse em {interest}'
        },
        en: {
          title: '{interest} - Scientific interests',
          description: 'A list of researchers interested in {interest}'
        }
      }
    })
    const metaInfo = {
      title: t('title', { interest: props.q }),
      meta: [{ name: 'description', content: t('description', { interest: props.q }) }]
    }
    useHeadSafe(metaInfo)
  },
  data() {
    return {
      ResearchersAPI: useResearchersAPI(this.$axios),
      currentPage: this.page,
      isSearching: false
    }
  },
  computed: {
    users() {
      return this.authors.items
    },
    totalResults() {
      return this.authors.totalItems
    }
  }
}
</script>
<style lang="scss" scoped>
.card-list {
  margin-top: 2rem;
}
</style>
